import { Typography } from "@mui/material";
import React from "react";

const DidNotLoad = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '90vh', textAlign: 'center' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#555', marginBottom: '1rem' }}>
                O carregamento levou mais tempo do que o esperado.
            </Typography>
            <Typography variant="body1" sx={{ color: '#555', marginBottom: '2rem' }}>
                Caso deseje, você pode tentar novamente clicando no botão abaixo.
            </Typography>
            <button
                onClick={() => window.location.reload()}
                style={{
                    padding: '0.8rem 1.5rem',
                    fontSize: '1rem',
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                }}
            >
                Recarregar agora
            </button>
        </div>
    );
}

export default DidNotLoad